import React from 'react';

export function MainTemplateComponent({
    className = '',
    outerChidren,
    innerChidren,
    children,
    id
}) {
    return (
        <div className={`content-main-wrapper neon ${className}`}>

            <div className="content-fix">

                <div className="flare"></div>

                <div className="content" id={id}>
                    {children}
                </div>
                
                {innerChidren}
            </div>

            {outerChidren}
        </div>
    );
};